import { UiStatesEnum } from '../../enums/ui-states.enum';
import { BehaviorSubject, Observable } from 'rxjs';
import { UiStates } from '../../enums/uiStates';
import { UiState } from '../../types/UiState';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UiStateService {
  public defaulState: UiState = {
    [UiStatesEnum.state]: UiStates.main,
    [UiStatesEnum.avatarUrl]: '',
    [UiStatesEnum.characterName]: '',
    [UiStatesEnum.chatId]: '',
  };
  private state: UiState;
  public updateStateData: BehaviorSubject<UiState>;
  private _showSwipingCards: BehaviorSubject<boolean>;

  get showSwipingCards(): Observable<boolean> {
    return this._showSwipingCards.asObservable();
  }

  constructor() {
    this.state = { ...this.defaulState };
    this.updateStateData = new BehaviorSubject(this.state);
    this._showSwipingCards = new BehaviorSubject(null);
  }

  public changeData(fieldName: UiStatesEnum, value: any): void {
    this.state[fieldName.toString()] = value;
    this.updateStateData.next(this.state);
  }

  setShowSwipingCards(value: boolean) {
    this._showSwipingCards.next(value);
  }
}
